export const smsAyar = {
    netgsmGetir: (istemci) => istemci.istek('/sms-ayar/netgsm'),
    netgsmKaydet: (istemci, giris) => istemci.istek('/sms-ayar/netgsm', {
        method: 'PATCH',
        body: JSON.stringify(giris),
    }),
    netgsmTest: (istemci, giris) => istemci.istek('/sms-ayar/netgsm/test', {
        method: 'POST',
        body: JSON.stringify(giris),
    }),
};
//# sourceMappingURL=sms-ayar.js.map